<div class="linebar">
  <svg>
    <line v-for="val in Data" :x1="val.x1" y1="0" :x2="val.x2" y2="0" :stroke="val.color" stroke-width="80"/>
  </svg>
  <div class="data">
    <div v-for="val in data" class="info"><div class="color" :style="{background:val.color}"></div><div class="number">{{val.value}}</div><div class="text">{{val.name}}</div></div>
  </div>
</div>